import { PrismButton, PrismButtonGroup } from "@prism-ui/react";
import type { ViewMode } from "./projects.utils";
import "./Projects.css";

interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  /** Restrict which view modes are offered. Defaults to all. */
  modes?: ViewMode[];
}

const OPTIONS: Array<{ mode: ViewMode; label: string }> = [
  { mode: "compact", label: "Compact" },
  { mode: "classic", label: "Classic" },
  { mode: "tagcloud", label: "Tag Cloud" },
  { mode: "timeline", label: "Timeline" },
];

export function ViewToggle({ value, onChange, modes }: ViewToggleProps) {
  const options = modes ? OPTIONS.filter((o) => modes.includes(o.mode)) : OPTIONS;
  return (
    <PrismButtonGroup
      className="projects-view-toggle"
      behavior="connected"
      collection="tablist"
      setAriaLabel="Project view mode"
    >
      {options.map((opt) => (
        <PrismButton
          key={opt.mode}
          tone={value === opt.mode ? "primary-brand" : "secondary"}
          display={value === opt.mode ? "fill" : "ghost"}
          size="sm"
          setAriaSelected={value === opt.mode}
          onPrismClick={() => onChange(opt.mode)}
        >
          {opt.label}
        </PrismButton>
      ))}
    </PrismButtonGroup>
  );
}
